import axios from "axios";

const url =  "/account/api/v1/company/currency/update-default";

function updateDefaultCurrencyConfig({
  currencyCode
}) {
  return new Promise((resolve, reject) => {
    axios.post(url, {
      currencyCode: currencyCode
    })
      .then(response => resolve(response))
      .catch(error => reject(error.response.data))
  })
}

export default updateDefaultCurrencyConfig;